<template>
  <div class="attachments-page">

    <div
      v-if="$can('create', permissionModule )"
      class="btn-actions-content"
    >
      <b-button
        class="btn-grad d-flex align-items-center"
        @click="openModal({ action: 'create'})"
      >
        <VSIcons
          name="AddSquare"
          width="22"
          height="22"
          class="pr-2"
        />
        <span class="align-middle">Adicionar</span>
      </b-button>
    </div>

    <b-input-group class="input-group-merge round search-input-filter">
      <b-input-group-prepend
        is-text
      >
        <VSIcons
          name="Search"
          color="#7D8E9E"
          width="18"
          height="18"
        />
      </b-input-group-prepend>
      <b-form-input
        id="filter-input"
        v-model="filter"
        placeholder="Buscar..."
        type="search"
      />
    </b-input-group>
    <b-table
      id="attachments-table"
      class="details-table mt-4"
      :items="items"
      :fields="fields"
      hover
      responsive
      details-td-class="align-middle"
      :busy="apiInCall"
      :per-page="perPage"
      :current-page="currentPage"
      small
      :filter="filter"
      :filter-included-fields="filterOn"
      empty-filtered-text="Não há resultados para sua pesquisa."
      empty-text="Não há registros para serem exibidos."
      show-empty
      @filtered="onFiltered"
    >
      <template #table-busy>
        <b-spinner variant="primary" />
      </template>
      <template
        v-if="$can('delete', permissionModule )"
        #head(select)
      >
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          @change="toggleAll('system/logbook', 'Logbook',)"
        />
      </template>
      <template
        v-if="$can('delete', permissionModule )"
        #cell(select)="row"
      >
        <b-form-checkbox
          v-model="selected"
          :value="row.item"
          @change="setItensToDelete({ itens: selected, api: 'system/logbook', fetchTable: 'Logbook' })"
        />
      </template>
      <template #cell(alert)="row">
        {{ row.item.alert ? 'Sim' : 'Não' }}
      </template>
      <template #cell(date)="row">
        <div class="d-flex align-items-center justify-content-center">
          {{ row.item.date | formatLocalDate }}
          <VSIcons
            name="calendar"
            class="ml-2"
            height="18"
          />
        </div>
      </template>
      <template #cell(description)="row">
        {{ row.item.description.length > 200 ? row.item.description.substring(0, 200) + '...' : row.item.description }}
      </template>
      <template #cell(actions)="row">
        <b-dropdown
          no-caret
          right
          variant="light"
          menu-class="dropdown-table-actions"
          toggle-class="button-dropdown-actions"
        >
          <template #button-content>
            <VSIcons
              name="Actions"
              width="5"
              height="22"
            />
          </template>
          <b-dropdown-item
            class="dropdown-table-item"
            @click="openModal({item: row.item, action: 'read'})"
          >
            <VSIcons
              name="Eye"
              width="21"
              height="21"
              color="#7D8E9E"
            />
            <span>
              Ver
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('update', permissionModule )" />
          <b-dropdown-item
            v-if="$can('update', permissionModule )"
            class="dropdown-table-item"
            @click="openModal({item: row.item, action: 'edit'})"
          >
            <VSIcons
              name="Edit"
              width="20"
              height="20"
              color="#7D8E9E"
            />
            <span>
              Editar
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('update', permissionModule )" />
          <b-dropdown-item
            v-if="$can('update', permissionModule )"
            class="dropdown-table-item"
            @click="uploadFile(row.item)"
          >
            <VSIcons
              name="PaperClip"
              width="22"
              height="22"
              color="#7D8E9E"
            />
            <span>
              Anexar
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('update', permissionModule )" />
          <b-dropdown-item
            v-if="$can('update', permissionModule )"
            class="dropdown-table-item"
            @click="fetchLogBook({item: row.item, action: 'read'})"
          >
            <VSIcons
              name="Export2"
              width="22"
              height="22"
              color="#7D8E9E"
            />
            <span>
              Gerar PDF
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('delete', permissionModule )" />
          <b-dropdown-item
            v-if="$can('delete', permissionModule )"
            class="dropdown-table-item"
            @click="deleteItem(row.item)"
          >
            <VSIcons
              name="TrashSquare"
              width="21"
              height="21"
              color="#7D8E9E"
            />
            <span>
              Excluir
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
      <template #cell(prazo)="row">
        <b-badge variant="warning">
          <div class="d-flex align-items-center">
            <VSIcons
              name="Clock"
              width="18"
              height="18"
              color="#FECD2F"
            />
            <span class="font-12 text-light">{{ row.item.prazo }}D</span>
          </div>
        </b-badge>
      </template>
      <template #cell(anotations)="row">
        <div class="d-flex align-items-center">
          {{ row.item.anotations }}
          <VSIcons
            name="NoteFillGradient"
          />
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="attachments-table"
    >
      <template #prev-text>
        <VSIcons name="ArrowLeft" />
      </template>
      <template #next-text>
        <VSIcons name="ArrowRight" />
      </template>
    </b-pagination>
    <VSModal
      width="970"
      name="AddLogbook"
      :properties="properties"
    />
    <VSModal
      width="570"
      :properties="itemToDelete"
      name="DeleteOneItem"
    />
    <VSModal
      name="UploadFile"
      :properties="properties"
    />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import {
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
  BSpinner,
  BBadge,
  BPagination,
} from 'bootstrap-vue'

import { formatLocalDate } from '@core/utils/filter'
import { tableConfig } from '@core/mixins/ui/forms'
import pdfMake from 'pdfmake/build/pdfmake'
import moment from 'moment'
import VSIcons from '@/assets/icons/VSIcons.vue'
import VSModal from '@/components/modals/VSModal.vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BTable,
    BButton,
    VSIcons,
    BFormCheckbox,
    BSpinner,
    BPagination,
    BBadge,
    VSModal,
  },
  filters: {
    formatLocalDate,
  },
  mixins: [
    tableConfig,
  ],
  props: {
    items: {
      type: Array,
      required: true,
    },
    module: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dataPfd: [],
      properties: { action: '' },
      itemToDelete: {
        item: {
          id: null,
        },
        api: 'system/logbook',
        fetch: 'Logbook',
      },
      fields: [
        {
          label: '',
          key: 'select',
          tdClass: 'align-middle',
        },
        {
          label: 'Data',
          key: 'date',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Título',
          key: 'title',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Descrição',
          key: 'description',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Tipo de Contato',
          key: 'contact_type',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'align-middle',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({ apiInCall: 'app/getApiInCall', user: 'auth/getUserData', myAccount: 'auth/getMyAccount' }),
    permissionModule() {
      if (this.module) { return 'licensesconditions' }
      return 'licensingagency'
    },
  },
  methods: {
    ...mapMutations({
      setItensToDelete: 'app/SET_ITENS_DELETE',
    }),
    openModal(item) {
      this.properties.module = this.module
      this.properties.item = item.item
      this.properties.action = item.action
      this.showModal('AddLogbook')
    },
    uploadFile(row) {
      this.properties.action = 'create'
      this.properties.relations = [{ name: 'logbook_id', id: row.id }]
      if (this.module) {
        this.properties.relations.push({ name: 'licensingCondition_id', id: this.$route.params.id })
      } else {
        this.properties.relations.push({ name: 'licensing_id', id: this.$route.params.id })
      }
      this.showModal('UploadFile')
    },
    docDefinition() {
      return {
        content: [
          {
            svg: '<svg viewBox="0 0 276 66" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M63.5546 25.6457L40.6975 3.01714C36.634 -1.00571 29.9673 -1.00571 25.8403 3.01714L2.98317 25.6457C-1.08033 29.6686 -1.08033 36.3314 2.98317 40.3543L25.8403 62.9829C29.9673 67.0057 36.634 67.0057 40.6975 62.9829L63.5546 40.3543C67.6816 36.2686 67.6816 29.6686 63.5546 25.6457ZM60.8879 37.6514L38.0308 60.28C35.4276 62.8571 31.1736 62.8571 28.5705 60.28L5.71333 37.6514C3.17364 35.0743 3.17364 30.8629 5.77682 28.2857L28.634 5.65714C31.1736 3.14286 35.4276 3.14286 38.0308 5.72L60.8879 28.3486C63.4911 30.8629 63.4911 35.0743 60.8879 37.6514Z" fill="#18AC81"/><path fill-rule="evenodd" clip-rule="evenodd" d="M33.3333 10.4343C30.7301 10.4343 28.5714 12.5086 28.5714 15.1486C28.5714 17.0972 29.7777 18.7943 31.492 19.4858V30.1715L28.6349 27.3429C29.2063 25.7086 28.8889 23.76 27.492 22.44C25.6508 20.6172 22.6031 20.6172 20.7619 22.44C18.9206 24.2629 18.9206 27.28 20.7619 29.1029C22.2222 30.5486 24.3809 30.8629 26.1587 30.0458L31.4285 35.2629V46.3886L23.5555 38.5315C24.2539 36.8343 23.9365 34.8229 22.4762 33.3772C20.6349 31.5543 17.5873 31.5543 15.746 33.3772C13.9047 35.2 13.9047 38.2172 15.746 40.04C17.1428 41.4229 19.2381 41.8 20.9524 41.0458L31.492 51.5429V58.0172C32.6984 58.3943 33.9682 58.3943 35.1746 58.0172V51.5429L45.7143 41.1086C47.4285 41.8 49.4603 41.4858 50.9206 40.1029C52.7619 38.28 52.7619 35.2629 50.9206 33.44C49.0793 31.6172 46.0317 31.6172 44.1904 33.44C42.7936 34.8229 42.4762 36.8972 43.1746 38.5943L35.1746 46.4515V35.3258L40.4444 30.1086C42.2222 30.9258 44.3809 30.6115 45.8412 29.1658C47.6825 27.3429 47.6825 24.3258 45.8412 22.5029C44 20.68 40.9524 20.68 39.1111 22.5029C37.7778 23.8229 37.3968 25.7715 37.9682 27.4058L35.1746 30.1715V19.4858C36.8889 18.7943 38.0952 17.0972 38.0952 15.1486C38.0952 12.5086 35.9365 10.4343 33.3333 10.4343ZM18.1587 35.8286C18.6666 35.3258 19.5555 35.3258 20.0635 35.8286C20.5714 36.3315 20.5714 37.2115 20.0635 37.7143C19.5555 38.2172 18.6666 38.2172 18.1587 37.7143C17.6508 37.1486 17.6508 36.3315 18.1587 35.8286ZM48.5079 35.8286C49.0158 36.3315 49.0158 37.2115 48.5079 37.7143C48 38.2172 47.1111 38.2172 46.6031 37.7143C46.0952 37.2115 46.0952 36.3315 46.6031 35.8286C47.1111 35.2629 47.9365 35.2629 48.5079 35.8286ZM43.4285 24.8286C43.9365 25.3315 43.9365 26.2115 43.4285 26.7143C42.9206 27.2172 42.0317 27.2172 41.5238 26.7143C41.0158 26.2115 41.0158 25.3315 41.5238 24.8286C42.0317 24.3258 42.9206 24.3258 43.4285 24.8286ZM23.1746 24.8286C23.6825 24.3258 24.5714 24.3258 25.0793 24.8286C25.5873 25.3315 25.5873 26.2115 25.0793 26.7143C24.5714 27.2172 23.6825 27.2172 23.1746 26.7143C22.6666 26.2115 22.6666 25.3943 23.1746 24.8286ZM33.3333 13.8286C32.5714 13.8286 32 14.3943 32 15.1486C32 15.9029 32.5714 16.4686 33.3333 16.4686C34.0952 16.4686 34.6666 15.84 34.6666 15.1486C34.6666 14.3943 34.0952 13.8286 33.3333 13.8286Z" fill="#076E5F" /> <path d="M102.349 55.6286H99.492V54.8115H106.095V55.6286H103.238V62.8572H102.349V55.6286ZM108.063 54.8115H113.206V55.6286H108.952V58.3944H112.698V59.2115H108.952V61.9772H113.206V62.7944H108.063V54.8115ZM119.238 62.9829C117.968 62.9829 117.016 62.6058 116.444 61.9144C115.809 61.2229 115.492 60.1544 115.492 58.8344C115.492 57.4515 115.809 56.4458 116.444 55.7544C117.079 55.0629 118.032 54.7486 119.238 54.7486C120.063 54.7486 120.889 54.9372 121.714 55.3144V56.1315C120.952 55.7544 120.19 55.5029 119.365 55.5029C118.349 55.5029 117.587 55.7544 117.143 56.3201C116.698 56.8229 116.444 57.7029 116.444 58.8344C116.444 59.9658 116.698 60.8458 117.143 61.3486C117.587 61.8515 118.349 62.1658 119.365 62.1658C120.254 62.1658 121.016 61.9772 121.714 61.6001V62.4172C120.889 62.7944 120.063 62.9829 119.238 62.9829ZM130.857 54.8115V62.8572H129.841L124.952 56.0686V62.8572H124.063V54.8115H125.079L129.968 61.6001V54.8115H130.857ZM136.952 62.9829C135.746 62.9829 134.857 62.6058 134.222 61.9144C133.587 61.2229 133.333 60.1544 133.333 58.8344C133.333 57.4515 133.651 56.4458 134.222 55.7544C134.857 55.0629 135.746 54.6858 136.952 54.6858C138.159 54.6858 139.111 55.0001 139.682 55.7544C140.317 56.4458 140.571 57.4515 140.571 58.8344C140.571 60.2172 140.254 61.2229 139.682 61.9144C139.111 62.6058 138.222 62.9829 136.952 62.9829ZM136.952 62.1658C137.905 62.1658 138.603 61.9144 139.048 61.3486C139.492 60.7829 139.746 59.9658 139.746 58.8344C139.746 57.7029 139.492 56.8229 139.048 56.3201C138.603 55.8172 137.905 55.5029 136.952 55.5029C136 55.5029 135.302 55.7544 134.857 56.3201C134.413 56.8858 134.222 57.7029 134.222 58.8344C134.222 59.9658 134.413 60.8458 134.857 61.3486C135.302 61.8515 136 62.1658 136.952 62.1658ZM143.111 54.8115H144V62.0401H148.127V62.8572H143.111V54.8115ZM153.524 62.9829C152.317 62.9829 151.429 62.6058 150.794 61.9144C150.159 61.2229 149.905 60.1544 149.905 58.8344C149.905 57.4515 150.222 56.4458 150.794 55.7544C151.429 55.0629 152.317 54.6858 153.524 54.6858C154.73 54.6858 155.619 55.0001 156.254 55.7544C156.889 56.4458 157.206 57.4515 157.206 58.8344C157.206 60.2172 156.889 61.2229 156.254 61.9144C155.619 62.6058 154.73 62.9829 153.524 62.9829ZM153.524 62.1658C154.476 62.1658 155.175 61.9144 155.619 61.3486C156.063 60.8458 156.254 59.9658 156.254 58.8344C156.254 57.7029 156.063 56.8229 155.619 56.3201C155.175 55.8172 154.476 55.5029 153.524 55.5029C152.571 55.5029 151.873 55.7544 151.429 56.3201C150.984 56.8858 150.73 57.7029 150.73 58.8344C150.73 59.9658 150.984 60.8458 151.429 61.3486C151.873 61.9144 152.571 62.1658 153.524 62.1658ZM163.111 62.9829C161.841 62.9829 160.889 62.6058 160.317 61.9144C159.682 61.2229 159.365 60.1544 159.365 58.8344C159.365 57.4515 159.682 56.4458 160.317 55.7544C160.952 55.0629 161.905 54.7486 163.111 54.7486C164 54.7486 164.889 54.9372 165.651 55.2515V56.1315C165.206 55.9429 164.762 55.8172 164.381 55.6915C164 55.5658 163.619 55.5029 163.175 55.5029C162.159 55.5029 161.397 55.7544 160.889 56.3201C160.381 56.8858 160.19 57.7029 160.19 58.8344C160.19 59.9658 160.444 60.8458 160.889 61.3486C161.397 61.9144 162.159 62.1658 163.175 62.1658C163.809 62.1658 164.444 62.0401 165.016 61.8515V59.5886H163.048V58.7086H165.905V62.3544C165.079 62.7944 164.127 62.9829 163.111 62.9829ZM168.698 54.8115H169.587V62.8572H168.698V54.8115ZM177.016 60.3429H173.524L172.571 62.8572H171.619L174.857 54.8115H175.746L178.984 62.8572H178.032L177.016 60.3429ZM176.698 59.5258L175.238 55.8801L173.841 59.5258H176.698ZM183.746 54.8115H188.889V55.6286H184.635V58.3944H188.381V59.2115H184.635V61.9772H188.889V62.7944H183.746V54.8115ZM196.635 62.9829C196.063 62.9829 195.619 62.9201 195.302 62.7944C194.984 62.6686 194.54 62.5429 194.095 62.2915V61.3486C194.413 61.6001 194.73 61.7886 195.175 61.9144C195.619 62.0401 196.127 62.1658 196.635 62.1658C197.206 62.1658 197.651 62.0401 197.968 61.7886C198.286 61.5372 198.413 61.2229 198.413 60.7829C198.413 60.4686 198.286 60.2172 198.159 60.0286C197.968 59.8401 197.778 59.6515 197.524 59.5258C197.27 59.4001 196.952 59.2744 196.444 59.0858C195.936 58.8972 195.556 58.7715 195.238 58.5829C194.921 58.3944 194.667 58.2058 194.476 57.8915C194.286 57.5772 194.159 57.2001 194.159 56.6972C194.159 56.3829 194.286 56.0686 194.413 55.7544C194.54 55.4401 194.857 55.1886 195.238 54.9372C195.619 54.7486 196.063 54.6229 196.698 54.6229C197.143 54.6229 197.46 54.6858 197.778 54.7486C198.032 54.8744 198.413 55.0001 198.857 55.1886V56.0686C198.794 56.0058 198.667 55.9429 198.413 55.8172C198.159 55.6915 197.905 55.5658 197.651 55.5029C197.397 55.4401 197.079 55.3772 196.762 55.3772C196.19 55.3772 195.809 55.5029 195.492 55.6915C195.238 55.9429 195.111 56.1944 195.111 56.5715C195.111 56.8858 195.175 57.1372 195.302 57.3258C195.429 57.5144 195.619 57.7029 195.873 57.8286C196.127 57.9544 196.444 58.0801 196.889 58.2058C197.397 58.3944 197.778 58.5201 198.095 58.7086C198.413 58.8344 198.73 59.0858 198.921 59.4001C199.175 59.7144 199.238 60.0915 199.238 60.5944C199.238 61.2229 199.048 61.7886 198.603 62.2286C198.286 62.7944 197.587 62.9829 196.635 62.9829ZM201.778 54.8115H202.667V62.8572H201.778V54.8115ZM207.746 62.9829C207.175 62.9829 206.73 62.9201 206.413 62.7944C206.095 62.6686 205.714 62.5429 205.206 62.2915V61.3486C205.524 61.6001 205.905 61.7886 206.286 61.9144C206.73 62.0401 207.238 62.1658 207.746 62.1658C208.317 62.1658 208.762 62.0401 209.079 61.7886C209.397 61.5372 209.524 61.2229 209.524 60.7829C209.524 60.4686 209.46 60.2172 209.27 60.0286C209.079 59.8401 208.889 59.6515 208.635 59.5258C208.381 59.4001 208.063 59.2744 207.556 59.0858C207.048 58.8972 206.667 58.7715 206.349 58.5829C206.032 58.3944 205.778 58.2058 205.587 57.8915C205.397 57.5772 205.27 57.2001 205.27 56.6972C205.27 56.3829 205.333 56.0686 205.524 55.7544C205.714 55.4401 205.968 55.1886 206.349 54.9372C206.73 54.7486 207.175 54.6229 207.809 54.6229C208.254 54.6229 208.571 54.6858 208.889 54.7486C209.206 54.8744 209.524 55.0001 209.968 55.1886V56.0686C209.905 56.0058 209.778 55.9429 209.524 55.8172C209.27 55.6915 209.016 55.5658 208.762 55.5029C208.508 55.4401 208.19 55.3772 207.873 55.3772C207.302 55.3772 206.921 55.5029 206.603 55.6915C206.349 55.9429 206.222 56.1944 206.222 56.5715C206.222 56.8858 206.286 57.1372 206.476 57.3258C206.603 57.5144 206.794 57.7029 207.048 57.8286C207.302 57.9544 207.619 58.0801 208.063 58.2058C208.571 58.3944 208.952 58.5201 209.333 58.7086C209.651 58.8344 209.905 59.0858 210.159 59.4001C210.413 59.7144 210.476 60.0915 210.476 60.5944C210.476 61.2229 210.286 61.7886 209.841 62.2286C209.397 62.7944 208.698 62.9829 207.746 62.9829ZM214.984 55.6286H212.127V54.8115H218.73V55.6286H215.873V62.8572H214.984V55.6286ZM220.762 54.8115H225.905V55.6286H221.587V58.3944H225.333V59.2115H221.587V61.9772H225.841V62.7944H220.698V54.8115H220.762ZM236 54.8115V62.8572H235.111V56.2572L232.127 60.3429L229.333 56.2572V62.8572H228.444V54.8115H229.397L232.19 59.0229L234.984 54.8115H236ZM243.429 60.3429H239.936L238.984 62.8572H238.032L241.27 54.8115H242.159L245.397 62.8572H244.444L243.429 60.3429ZM243.111 59.5258L241.651 55.8801L240.254 59.5258H243.111ZM249.651 62.9829C249.079 62.9829 248.635 62.9201 248.317 62.7944C248 62.6686 247.619 62.5429 247.111 62.2915V61.3486C247.429 61.6001 247.809 61.7886 248.19 61.9144C248.635 62.0401 249.143 62.1658 249.651 62.1658C250.286 62.1658 250.73 62.0401 250.984 61.7886C251.302 61.5372 251.429 61.2229 251.429 60.7829C251.429 60.4686 251.365 60.2172 251.175 60.0286C250.984 59.8401 250.794 59.6515 250.54 59.5258C250.286 59.4001 249.968 59.2744 249.46 59.0858C248.952 58.8972 248.571 58.7715 248.254 58.5829C247.936 58.3944 247.682 58.2058 247.492 57.8915C247.302 57.5772 247.175 57.2001 247.175 56.6972C247.175 56.3829 247.238 56.0686 247.429 55.7544C247.619 55.4401 247.873 55.1886 248.254 54.9372C248.635 54.7486 249.079 54.6229 249.714 54.6229C250.159 54.6229 250.476 54.6858 250.794 54.7486C251.111 54.8744 251.429 55.0001 251.873 55.1886V56.0686C251.809 56.0058 251.682 55.9429 251.429 55.8172C251.175 55.6915 250.921 55.5658 250.667 55.5029C250.413 55.4401 250.095 55.3772 249.778 55.3772C249.206 55.3772 248.762 55.5029 248.508 55.6915C248.254 55.9429 248.127 56.1944 248.127 56.5715C248.127 56.8858 248.19 57.1372 248.381 57.3258C248.508 57.5144 248.698 57.7029 248.952 57.8286C249.206 57.9544 249.524 58.0801 249.968 58.2058C250.476 58.3944 250.857 58.5201 251.238 58.7086C251.556 58.8344 251.809 59.0858 252.063 59.4001C252.317 59.7144 252.381 60.0915 252.381 60.5944C252.381 61.2229 252.19 61.7886 251.746 62.2286C251.238 62.7944 250.54 62.9829 249.651 62.9829Z" fill="#919396" /> <path d="M107.238 6.7887L94.2222 40.103H88.4444L75.8095 7.04012C79.2381 6.7887 82.0317 7.54298 83.3651 10.6858L91.746 33.6916L100.063 10.6858C101.397 7.10298 103.746 6.97727 107.238 6.7887Z" fill="#18AC81" /> <path d="M134.794 17.5372C135.746 16.9715 137.333 16.3429 139.556 15.7143C141.778 15.0229 144 14.7086 146.222 14.7086C147.556 14.7086 148.698 14.8972 149.651 15.3372V19.4858C148.698 19.36 147.619 19.2972 146.286 19.2972C144.063 19.2972 142.032 19.4858 140.063 19.8V40.1029H134.794V17.5372Z" fill="#18AC81" /> <path d="M174.095 2.95435V34.8229C174.095 36.1429 173.524 37.2743 172.444 38.1543C171.365 39.0343 169.968 39.7258 168.317 40.1658C166.667 40.6058 164.952 40.7943 163.175 40.7943C159.619 40.7943 156.698 39.7886 154.349 37.7772C152.063 35.7658 150.921 32.3086 150.921 27.2801C150.921 23.2572 151.936 20.1772 153.905 17.9143C155.873 15.6515 158.794 14.5201 162.667 14.5201C163.556 14.5201 164.635 14.6458 165.778 14.8343C166.984 15.0858 168 15.4001 168.952 15.9029V7.10292C168.952 4.3372 171.175 3.08006 174.095 2.95435ZM168.889 20.5543C168.063 20.1143 167.238 19.7372 166.222 19.4858C165.206 19.2343 164.254 19.1086 163.365 19.1086C158.603 19.1086 156.254 21.8743 156.254 27.4686C156.254 30.2343 156.762 32.4343 157.841 34.0058C158.921 35.5772 160.762 36.3943 163.429 36.3943C164.952 36.3943 166.286 36.2058 167.302 35.8286C168.381 35.4515 168.889 35.0115 168.889 34.3829V20.5543Z" fill="#18AC81" /> <path d="M190.159 14.6458C194.095 14.6458 196.952 15.9029 198.73 18.3543C200.254 20.4915 201.143 23.3829 201.333 26.9658V27.0286C201.333 27.2172 201.333 27.4058 201.333 27.6572C201.333 28.6629 201.016 28.8515 200.381 28.8515H199.619H199.556H183.746C183.873 31.3029 184.635 33.1258 185.905 34.4458C187.175 35.7029 189.016 36.3315 191.365 36.3315C192.889 36.3315 194.349 36.1429 195.81 35.7658C197.206 35.3886 198.413 34.8858 199.492 34.32V39.16C196.889 40.2915 193.905 40.8572 190.54 40.8572C186.794 40.8572 183.81 39.7258 181.651 37.4629C179.492 35.2 178.413 31.9943 178.413 27.8458C178.413 23.5715 179.429 20.3658 181.46 18.04C183.556 15.7772 186.476 14.6458 190.159 14.6458ZM190.032 18.92C188.254 18.92 186.857 19.36 185.905 20.3029C184.889 21.2458 184.254 22.8172 183.937 25.0172H196.127C195.873 22.88 195.302 21.3715 194.349 20.3658C193.333 19.4229 191.873 18.92 190.032 18.92Z" fill="#18AC81" /> <path d="M216.825 40.7315C214.476 40.7315 212.508 40.5429 210.857 40.1029C209.27 39.7258 207.555 39.0344 205.778 38.0915V32.6229C207.048 33.6915 208.698 34.5087 210.54 35.2001C212.444 35.8915 214.413 36.2058 216.508 36.2058C218.54 36.2058 220.063 35.7658 221.079 34.9487C222.095 34.1315 222.667 32.9372 222.667 31.4287C222.667 30.3601 222.349 29.5429 221.778 28.9144C221.206 28.2229 220.444 27.7201 219.555 27.2801C218.667 26.8401 217.397 26.3372 215.746 25.7715L214.667 25.3944C212.825 24.7658 211.302 24.1372 210.159 23.4458C208.952 22.7544 208 21.8115 207.175 20.6172C206.349 19.4229 205.968 17.8515 205.968 15.9029C205.968 14.3315 206.349 12.8229 207.175 11.3772C208 9.93151 209.206 8.80008 210.921 7.85722C212.635 6.97722 214.73 6.47437 217.333 6.47437C219.175 6.47437 220.762 6.66294 222.032 6.97722C223.302 7.35437 224.762 7.92008 226.54 8.73722V14.0801C224.825 13.0115 223.365 12.2572 222.095 11.6915C220.889 11.1887 219.428 10.9372 217.714 10.9372C215.746 10.9372 214.222 11.3144 213.206 12.1315C212.19 12.9487 211.682 13.9544 211.682 15.2744C211.682 16.3429 212 17.2858 212.508 17.9144C213.079 18.6058 213.841 19.1087 214.73 19.5487C215.619 19.9887 216.952 20.4287 218.73 20.9944C220.762 21.6858 222.476 22.3144 223.809 23.0687C225.143 23.7601 226.286 24.7658 227.175 26.0229C228.063 27.2801 228.444 28.8515 228.444 30.7372C228.444 32.5601 228.063 34.2572 227.238 35.7029C226.413 37.2115 225.143 38.4058 223.428 39.3487C221.524 40.2915 219.365 40.7315 216.825 40.7315Z" fill="#076E5F" /> <path d="M255.746 15.2743L245.397 41.6743C243.238 47.08 240.381 49.72 236.698 49.72C235.429 49.72 234.286 49.5314 233.397 49.1543V44.6914C234.222 45.0057 235.048 45.1943 235.873 45.1943C237.206 45.1943 238.222 44.7543 238.984 43.8743C239.746 42.9943 240.381 41.7371 240.889 39.9771L230.603 15.2114H231.619C235.302 15.3371 237.016 16.5943 237.778 18.48L243.429 33.8171L249.143 18.2914C249.841 16.5314 251.429 15.3371 254.794 15.2743H255.746Z" fill="#076E5F" /> <path d="M266.032 40.8572C264.381 40.8572 262.921 40.6686 261.714 40.3543C260.508 40.04 259.175 39.5372 257.778 38.8458V33.9429C259.302 34.8858 260.635 35.5772 261.905 36.0172C263.175 36.4572 264.508 36.7086 266.032 36.7086C267.492 36.7086 268.635 36.3943 269.397 35.8286C270.222 35.2629 270.603 34.5086 270.603 33.5658C270.603 32.6858 270.286 31.9943 269.587 31.5543C268.889 31.1143 267.873 30.6743 266.476 30.1715L265.333 29.7943C262.984 29.2286 261.143 28.4115 259.746 27.3429C258.349 26.2743 257.651 24.64 257.651 22.3772C257.651 20.6172 258.159 19.1715 259.048 18.04C260 16.9086 261.143 16.0286 262.603 15.5258C264 15.0229 265.524 14.7086 267.111 14.7086C268.698 14.7715 270.095 14.96 271.175 15.2743C272.254 15.6515 273.46 16.1543 274.794 16.7829V21.2458C273.079 20.3658 271.746 19.7372 270.857 19.4229C269.968 19.1086 268.889 18.92 267.683 18.92C266.286 18.92 265.206 19.1715 264.381 19.6743C263.556 20.1772 263.111 20.8686 263.111 21.7486C263.111 22.8172 263.556 23.5715 264.381 24.0743C265.206 24.5772 266.54 25.0172 268.254 25.52C269.905 25.96 271.238 26.4 272.254 26.84C273.27 27.28 274.095 27.9715 274.857 28.9143C275.619 29.92 276 31.24 276 32.9372C275.936 35.5772 274.984 37.5258 273.079 38.8458C271.111 40.2286 268.762 40.8572 266.032 40.8572Z" fill="#076E5F" /> <path d="M118.603 14.6458C122.54 14.6458 125.397 15.9029 127.175 18.3543C128.762 20.4915 129.587 23.3829 129.778 26.9658V27.0286C129.778 27.2172 129.778 27.4058 129.778 27.6572C129.778 28.6629 129.46 28.8515 128.762 28.8515H128H127.937H112.127C112.317 31.3029 113.016 33.1258 114.286 34.4458C115.556 35.7029 117.397 36.3315 119.746 36.3315C121.27 36.3315 122.73 36.1429 124.127 35.7658C125.524 35.3886 126.73 34.8858 127.81 34.32V39.16C125.206 40.2915 122.222 40.8572 118.857 40.8572C115.111 40.8572 112.127 39.7258 109.968 37.4629C107.81 35.2 106.73 31.9943 106.73 27.8458C106.73 23.5715 107.746 20.3658 109.778 18.04C112 15.7772 114.857 14.6458 118.603 14.6458ZM118.413 18.92C116.635 18.92 115.238 19.36 114.286 20.3029C113.27 21.2458 112.635 22.8172 112.317 25.0172H124.508C124.254 22.88 123.683 21.3715 122.667 20.3658C121.714 19.4229 120.317 18.92 118.413 18.92Z" fill="#18AC81" /> </svg>',
            width: 230,
            height: 80,
            style: 'svgStyle',
          },
          { text: 'Gestão de documentos - Diário de Bordo', style: 'header', margin: [0, 0, 0, 0] },
          {
            text: `Data do relatório: ${moment(this.dateReport).format('LL')}`, style: 'subheader', color: '#7D8E9E', margin: [20, 0, 0, 20],
          },
          {
            text: `Nome ou Nome Fantasia do Cliente/Conta: ${this.user.person_full_name || this.myAccount.corporate_name}`, style: 'infoReport',
          },
          {
            text: `CPF ou CNPJ do Cliente/Conta: ${this.myAccount.cpf || this.myAccount.cnpj}`, style: 'infoReport',
          },
          {
            text: `Nome do usúario: ${this.user.full_name}`, style: 'infoReport',
          },
          {
            text: `E-mail: ${this.user.email}`, style: 'infoReport',
          },
          this.dataPdf ? {
            style: 'tableExample',
            table: {
              headerRows: 1,
              body: [
                [
                  { text: 'Data', style: 'tableHeader' },
                  { text: 'Título', style: 'tableHeader' },
                  { text: 'Descrição', style: 'tableHeader' },
                  { text: 'Tipo de contato', style: 'tableHeader' },
                ],
                [
                  { text: `${formatLocalDate(this.dataPdf.item.date)}`, style: 'tableContent' },
                  { text: `${this.dataPdf.item.title}`, style: 'tableContent' },
                  { text: `${this.dataPdf.item.description}`, style: 'tableContent' },
                  { text: `${this.dataPdf.item.contact_type}`, style: 'tableContent' },
                ],
              ],
            },
          } : null,
        ],
        styles: {
          svgStyle: {
            margin: [120, 0, 0, 0],
          },
          header: {
            fontSize: 28,
            bold: true,
            color: '#33383C',
            margin: [0, 0, 0, 0],
            alignment: 'justify',
          },
          subheader: {
            fontSize: 13,
            margin: [0, 0, 0, 0],
          },
          infoReport: {
            margin: [0, 0, 0, 0],
            color: '#7D8E9E',
          },
          titleTable: {
            fontSize: 13,
            bold: true,
            margin: [0, 5, 0, 10],
            color: '#33383C',
          },
          subTitleTable: {
            fontSize: 10,
            margin: [0, 0, 0, 0],
            color: '#33383C',
          },
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fillColor: '#33383C',
            fontSize: 10,
            color: '#F6F9F9',
          },
          tableContent: {
            bold: true,
            fillColor: '#F6F9F9',
            fontSize: 10,
            color: '#33383C',
          },
        },
        defaultStyle: {
          alignment: 'justify',
          font: 'Roboto',
        },
      }
    },
    makePdf(doc) {
      pdfMake.createPdf(doc).print()
    },
    fetchLogBook(item) {
      console.log(item)
      this.dataPdf = item
      console.log(this.dataPdf)
      this.makePdf(this.docDefinition())
    },
  },
}
</script>
<style lang="scss">

</style>
